<plotly-plot
  [data]="graph.data"
  [layout]="graph.layout"
  *ngIf="this.chartData"
></plotly-plot>
